module.exports = __webpack_public_path__ + "static/barak-hex-27bb7a314b5e0f9a6f029e278034e849.png";